$(document).on('turbo:load turbo:render',() => {

    $(".authorizer-name").on("change", function (e) {

        //@ts-ignore
       $( "#authorizerName").text(e.target.value)
    });


});